
import { Swiper, SwiperSlide, SwiperCore } from "swiper-vue2";
import { Navigation } from "swiper";
import "swiper/swiper-bundle.css";
import RelatedProductCardPDP from "~/components/common/RelatedProductCardPDP.vue";
import CarretRightSvg from "~/components/svg/CarretRightSvg.vue";
SwiperCore.use([Navigation]);

export default {
  name: "RelatedProductsBlockPDP",
  components: {
    Swiper,
    SwiperSlide,
    RelatedProductCardPDP,
    CarretRightSvg,
  },
  props: {
    data: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      swiperInstance: null,
      isBeginning: true,
      isEnd: false,
    };
  },
  computed: {
    mapedData() {
      return this.data.map((el) => ({
        ...el,
        image: el?.images?.[0]?.url || el?.image,
      }));
    },
  },
  methods: {
    onSwiper(swiper) {
      this.swiperInstance = swiper;
      this.updateNavigationState();
    },
    onSlideChange() {
      this.updateNavigationState();
    },
    slidePrev() {
      if (this.swiperInstance) {
        this.swiperInstance.slidePrev();
      }
    },
    slideNext() {
      if (this.swiperInstance) {
        this.swiperInstance.slideNext();
      }
    },
    updateNavigationState() {
      if (this.swiperInstance) {
        this.isBeginning = this.swiperInstance.isBeginning;
        this.isEnd = this.swiperInstance.isEnd;
      }
    },
  },
};
